import { DataBean } from "../DataBean";

export class SignListFormat extends DataBean {

    public async getSignListFormat(idsignlistformat: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.orange.finance.processcontract.bean.SignListFormat_getSignListFormat_Number", [idsignlistformat]);
    }

    public async getSignListFormatCatalogPorPropiedades(properties: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getSignListFormatCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async updateSignListFormat(bean: any): Promise<any> {
        return this.getCustomService(
            "ProcessContractERP",
            "com.orange.finance.processcontract.bean.SignListFormat_updateSignListFormat_com.orange.finance.processcontract.bean.SignListFormat",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.orange.finance.processcontract.bean.SignListFormat"
                }
            ]
        );
    }

}